module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Mouse.eeaf72da.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Mouse.svg
// module id = 1609
// module chunks = 0